export enum SwitchLabelPlacement {
    Start = "start",
    End = "end"
}
